const Toggle = {
  init(element = document) {
    const triggers = element.querySelectorAll('[data-toggle]');

    if (triggers.length) {
      [].forEach.call(triggers, trigger => {
        trigger.addEventListener('click', this.handleToggle);
      });
    }
  },

  handleToggle(ev) {
    ev.preventDefault();
    document.body.classList.toggle(`has-${ev.currentTarget.dataset.toggle}-open`);
  },
};

export default Toggle;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/go-adventure-blog/src/scripts/modules/toggle.js